import axios from 'axios';
import { apiMainUrl } from '../apiConfig';

const API_BASE_URL = apiMainUrl + 'scheduler'; // Adjust if needed

// Fetch all scheduled jobs
const getScheduledJobs = async (token) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/jobs`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        console.error('Failed to fetch scheduled jobs:', error);
        throw error;
    }
};

// Get details of a specific scheduled job
const getScheduledJobDetails = async (jobId, token) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/jobs/${jobId}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        console.error('Failed to fetch scheduled job details:', error);
        throw error;
    }
};

// Create a new scheduled job
const createScheduledJob = async (jobData, token) => {
    try {
        const response = await axios.post(`${API_BASE_URL}/jobs`, jobData, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        console.error('Failed to create scheduled job:', error);
        throw error;
    }
};

// Update an existing scheduled job
const updateScheduledJob = async (jobId, jobData, token) => {
    try {
        const response = await axios.put(`${API_BASE_URL}/jobs/${jobId}`, jobData, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        console.error('Failed to update scheduled job:', error);
        throw error;
    }
};

// Delete a scheduled job
const deleteScheduledJob = async (jobId, token) => {
    try {
        const response = await axios.delete(`${API_BASE_URL}/jobs/${jobId}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        console.error('Failed to delete scheduled job:', error);
        throw error;
    }
};

// Trigger a job immediately
const triggerScheduledJob = async (jobId, token) => {
    try {
        const response = await axios.post(`${API_BASE_URL}/jobs/${jobId}/trigger`, {}, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        console.error('Failed to trigger scheduled job:', error);
        throw error;
    }
};

export const SchedulerDataService = {
    getScheduledJobs,
    createScheduledJob,
    updateScheduledJob,
    deleteScheduledJob,
    triggerScheduledJob,
    getScheduledJobDetails
};
